import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ComponentBase } from '../../../_infrastructure/classes/componentBase';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { UsuariosService } from '../../../../../../app/components/_mantenimiento/usuarios/usuarios.service';
import { UsuarioViewModel } from '../../../../../../app/components/_mantenimiento/usuarios/usuarios.types';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-migracionusuariopopup',
    templateUrl: './migracionUsuarioPopup.component.html',
})
export class MigracionUsuarioPopupComponent extends ComponentBase implements OnInit {
    @Output() selected = new EventEmitter<UsuarioViewModel>();

    display = false;

    constructor(private fb: UntypedFormBuilder, protected notificationService: NotificationService, private usuarioService: UsuariosService) {
        super();
    }

    ngOnInit() {
        this.createForm();
    }

    private createForm(): void {
        this.form = this.fb.group({
            NombreUsuario: ['', Validators.required],
            Password: ['', Validators.required],
        });
    }

    private cleanForm(): void {
        this.form.setValue({
            NombreUsuario: '',
            Password: '',
        });
        this.form.markAsUntouched();
    }

    onLogin(): void {
        if (!this.form.valid) {
            return;
        }

        let params = new HttpParams();

        params = params.append('nombreusuario', this.form.value.NombreUsuario);
        params = params.append('passw', this.form.value.Password);

        this.loading = true;

        this.usuarioService.getUsuarioExternoCexvegSL(params).subscribe({
            next: result => {
                if (result) {
                    this.addSuccessMessage('Usuario recuperado con éxito');

                    this.display = false;
                    this.selected.emit(result);
                } else {
                    this.addErrorMessage('Error al recuperar el usuario');
                }
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    showDialog(): void {
        this.cleanForm();
        this.display = true;
    }

    cancelDialog(): void {
        this.display = false;
    }

    noAccepted(): boolean {
        return !this.form.valid || this.form.pristine;
    }
}
